export const isNotBlankArray = (item) => {
    if (Array.isArray(item)) {
        item = item.filter(subItem => subItem);
        if (0 in new Object(item)) {
            return true;
        }
    }
    return false;
};
